/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate user types in the overall application.
   Developer: Mohammad Saquib Khan, Created Date: 31-July-2025 
</summary>
*/
enum genderTypeEnum{
    Male = 0,
    Female = 1,
    NotSet = 2,
    MaleFemale = 3, // Means Either Male or Female
    FemaleNotSet = 4, // Means Either Female or Not Set
    MaleNotSet = 5, // Means Either Male or Not Set
}

export default genderTypeEnum;